import React from 'react';
import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import DEVICES from '../../common/styles/devices';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

interface CaptchaContainerProps {
  marginTop: number;
  marginBottom: number;
}

const CaptchaMessageContainer = styled.div.withConfig({
  shouldForwardProp: () => false
})<CaptchaContainerProps>`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  text-align: center;
  color: ${COLORS.textLightGrey};
  font-family: ${FONT_FAMILY.hellix.regular};
  margin-bottom: ${({ marginBottom }) => marginBottom}px;
  margin-top: ${({ marginTop }) => marginTop}px;
  line-height: 20px;
  max-width: 320px;

  .links {
    color: ${COLORS.darkBlue};
  }

  @media ${DEVICES.mobileL} {
    width: 300px;
  }
  @media ${DEVICES.mobileS} {
    width: 100%;
  }
`;

const CaptchaMessage: React.FC = (props: any) => {
  return (
    <CaptchaMessageContainer marginTop={props.marginTop} marginBottom={props.marginBottom}>
      This site is protected by reCAPTCHA and the Google
      <a
        href="https://policies.google.com/privacy"
        rel="noopener noreferrer"
        target="_blank"
        className="links"
      >
        {' '}
        Privacy Policy
      </a>{' '}
      and
      <a
        href="https://policies.google.com/terms"
        rel="noopener noreferrer"
        target="_blank"
        className="links"
      >
        {' '}
        Terms of Service
      </a>{' '}
      apply.
    </CaptchaMessageContainer>
  );
};

export default CaptchaMessage;
